// Procedural decorations (paint splatters, coin & chip stacks). Seeded so they render identically every load.

function rng(seed) {
  return function () {
    seed |= 0; seed = seed + 0x6D2B79F5 | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function splatSVG(seed, color) {
  const r = rng(seed), cx = 100, cy = 86, n = 18, pts = [];
  let i, d;
  for (i = 0; i < n; i++) {
    const a = i / n * Math.PI * 2, rad = 34 + r() * 30 * (i % 2 ? 1 : .55);
    pts.push([cx + Math.cos(a) * rad, cy + Math.sin(a) * rad * .85]);
  }
  const mid = (p, q) => [(p[0] + q[0]) / 2, (p[1] + q[1]) / 2];
  const m = mid(pts[n - 1], pts[0]);
  d = 'M' + m[0].toFixed(1) + ' ' + m[1].toFixed(1);
  for (i = 0; i < n; i++) {
    const p = pts[i], q = mid(p, pts[(i + 1) % n]);
    d += 'Q' + p[0].toFixed(1) + ' ' + p[1].toFixed(1) + ' ' + q[0].toFixed(1) + ' ' + q[1].toFixed(1);
  }
  let s = '<svg viewBox="0 0 200 220"><g fill="' + color + '"><path d="' + d + '"/>';
  for (i = 0; i < 16; i++) {
    const a2 = r() * Math.PI * 2, dist = 60 + r() * 36;
    s += '<circle cx="' + (cx + Math.cos(a2) * dist).toFixed(1) + '" cy="' + (cy + Math.sin(a2) * dist * .8).toFixed(1) + '" r="' + (1.5 + r() * 5).toFixed(1) + '"/>';
  }
  for (i = 0; i < 5; i++) {
    const x = cx - 40 + r() * 80, len = 30 + r() * 70, w = 3 + r() * 5;
    s += '<rect x="' + x.toFixed(1) + '" y="' + (cy + 10) + '" width="' + w.toFixed(1) + '" height="' + (len + 30).toFixed(1) + '" rx="' + (w / 2).toFixed(1) + '"/>' +
      '<circle cx="' + (x + w / 2).toFixed(1) + '" cy="' + (cy + 40 + len).toFixed(1) + '" r="' + (w * .85).toFixed(1) + '"/>';
  }
  return s + '</g></svg>';
}

export function stackSVG(kind, n, seed) {
  const r = rng(seed), step = kind === 'coin' ? 8 : 9, H = n * step + 26;
  const pal = {
    coin: ['#a86a00', '#e3a200', '#ffd23a', '#fff2a8'],
    gold: ['#9a6400', '#e8a800', '#ffcc2e', '#fff'],
    blue: ['#0b2a9e', '#1e5bff', '#3f7dff', '#fff'],
  }[kind];
  let s = '<svg viewBox="0 0 60 ' + H + '" style="filter:drop-shadow(0 0 6px rgba(255,200,0,.45))">';
  for (let i = 0; i < n; i++) {
    const y = H - 14 - i * step, x = (r() - .5) * (i > n - 4 ? 5 : 3);
    s += '<g transform="translate(' + x.toFixed(1) + ' 0)">' +
      '<ellipse cx="30" cy="' + (y + step) + '" rx="26" ry="8" fill="' + pal[0] + '"/>' +
      '<rect x="4" y="' + y + '" width="52" height="' + step + '" fill="' + pal[1] + '"/>' +
      (kind === 'coin' ? '' : '<rect x="4" y="' + y + '" width="52" height="' + step + '" fill="none" stroke="' + pal[3] + '" stroke-width="' + step + '" stroke-dasharray="5 7" opacity=".85"/>') +
      '<ellipse cx="30" cy="' + y + '" rx="26" ry="8" fill="' + pal[2] + '" stroke="' + pal[3] + '" stroke-width="1.2"/></g>';
  }
  const top = H - 14 - (n - 1) * step;
  s += '<text x="30" y="' + (top + 4) + '" text-anchor="middle" font-family="Montserrat,sans-serif" font-weight="900" font-size="11" fill="' + pal[0] + '">' + (kind === 'coin' ? '$' : '♛') + '</text>';
  return s + '</svg>';
}

// [left%, top%, width%, color, seed, opacity] — desktop only
export const SPLATS = [
  [31, 9, 13, '#FF2BD6', 3, .75], [45, 5, 11, '#22D3FF', 7, .7], [30.5, 47, 9, '#FFE600', 11, .65],
  [47, 50, 11, '#8B2BFF', 5, .8], [52.5, 14, 7, '#FFE600', 9, .7], [53, 64, 8, '#FF2BD6', 13, .7],
];

// [left, top, width, color, desktopOnly]
export const HAZES = [
  ['31%', '16%', '25%', 'rgba(255,43,214,.32)', true],
  ['57%', '18%', '17%', 'rgba(34,211,255,.25)', true],
  ['10%', '58%', '80%', 'rgba(255,43,214,.22)', false],
];
